export default __webpack_public_path__ + "static/media/fasting_ate@2x.1c1c9749.jpg";